import { tickerNews } from "@/mocks/maydayContent";

export default function TopBar() {
  const list = [...tickerNews, ...tickerNews];
  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto flex w-full max-w-[1200px] items-center px-4 md:px-6 py-2">
        <div className="mr-4 hidden shrink-0 items-center gap-2 sm:flex">
          <i className="ri-flashlight-fill text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i>
          <span className="text-xs font-medium tracking-wide whitespace-nowrap text-primary-200">今日聚焦</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center">
            {list.map((n, idx) => (
              <span key={idx} className="flex items-center whitespace-nowrap px-4 text-xs text-background-200/90">
                <i className="ri-record-circle-line text-primary-400 mr-2 text-[10px] w-3 h-3 flex items-center justify-center"></i>
                {n}
              </span>
            ))}
          </div>
        </div>
        <a
          href="#hot"
          className="ml-3 hidden shrink-0 items-center gap-1 text-xs font-medium text-background-100 hover:text-primary-200 transition-colors md:flex"
        >
          更多
          <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center text-xs"></i>
        </a>
      </div>
    </div>
  );
}